import React from 'react';
import Button from '@pattern-library/buttons';
import PropTypes from 'prop-types';
const propTypes = {
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  value: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
  status: PropTypes.oneOf(['disabled'])
};
function ButtonCell(props) {
  const {
    id,
    value,
    onClick,
    className,
    status
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: "asc-table-component-editable-cell"
  }, /*#__PURE__*/React.createElement(Button, {
    id: id,
    text: value,
    clickHandler: onClick,
    className: className,
    disabled: status === 'disabled'
  }));
}
ButtonCell.propTypes = propTypes;
export default ButtonCell;